import register from '../register.js';
import dom from '../lib/util/dom.js';

register( 'email-subscribe-modal', function() {
  let parent = document.querySelector('.email-modal');
  let beforeModal = parent.querySelector('.modal__content--before');
  let afterModal = parent.querySelector('.modal__content--after');
  let form = parent.querySelector('.email-form form');
  let input = form.querySelector('.email');
  let zipCode = form.querySelector('.zipcode');
  let message = form.querySelector('.message');

  // listen for form submission
  form.addEventListener( 'submit', submit, false );
  // listen for input change and clear any messaging
  input.addEventListener( 'input', removeMessage, false );

  // show a message ( elememnt, message string, add error class?)
  function showMessage( msg, err ) {
    message.textContent = msg || 'An error occurred';
    message.style.display = 'block';

    if ( err ) {
      dom.addClass( message, 'error' );
    } else {
      dom.removeClass( message, 'error' );
      dom.removeClass( beforeModal, 'showing' );
      dom.addClass( afterModal, 'showing' );
    }

  }

  // show a message indicating successful submission
  function showSuccess() {
    showMessage( message, false );
  }

  // show a message indicating unsuccessful submission
  function showError() {
    showMessage( 'Uh-oh. Please try that again.', true );
  }

  // remove/hide messaging
  function removeMessage() {
    message.style.display = 'none';
    dom.removeClass( afterModal, 'showing' );
    dom.addClass( beforeModal, 'showing' );
  }

  // handle form submission
  function submit( ev ) {

    let opts = { method: 'POST', url: '/email/subscription' };
    let payload = {
      email: input.value,
      zipcode: zipCode.value
    };

    ev.preventDefault();
    ( window.dataLayer || [] ).push({ event: 'int-sub-click' });

    dom.ajax( opts, payload, function( err ) {
      if ( err ) {
        return showError( message );
      }

      input.value = '';
      zipCode.value = '';

      acumen.track(
        'web-submit-get_updates',
        {
          email: payload.email,
          postal_code: payload.zipcode
        }
      );
      showSuccess();
    });
  }

});

export default undefined;
